<template>
  <div class="set" style="background: #fff">
    <van-nav-bar
      @click-left="onClickLeft"
      :title="$t('m.rlb_span0')"
      left-text=""
      left-arrow
    ></van-nav-bar>
    <div class="top-rlb-box" style="height: 300px">
      <div class="top-rlb">
        <div class="rlb-title">{{ $t("m.rlb_span7") }}</div>
        <div class="rlb-mon rlb-title">{{ total_money }}</div>
        <div class="rlb-yestoday">
          {{ $t("m.rlb_span2") }}：<span>¥{{ day_into }}</span>
        </div>
        <div class="rlb-btns" style="padding: 0px">
          <router-link to="/rlbout" class="rlb-btn1" style="margin-right: 20px">
            <div>{{ $t("m.rlb_span4") }}</div>
          </router-link>
          <router-link to="/rlbadd" class="rlb-btn2">
            <div>{{ $t("m.rlb_span5") }}</div>
          </router-link>
        </div>
      </div>
    </div>

    <div
      style="
        box-shadow: 0px 0px 16px #eaeaea;
        margin: 0 12px;
        display: flex;
        align-items: center;
        border-radius: 5px;
        height: 80px;
        margin-top: -60px;
        background-color: #fff;
      "
    >
      <div class="rlb-li" style="text-align: center; flex: 1">
        <div class="rlb-t" style="font-size: 16px; color: #333">
          {{ $t("m.rlb_span3") }}
        </div>
        <div style="margin-top: 5px; font-size: 13px; color: #999">
          {{ income }}
        </div>
      </div>
      <div style="width: 1px; height: 44px; background-color: #eee"></div>
      <div class="rlb-li" style="text-align: center; flex: 1">
        <div class="rlb-t" style="font-size: 16px; color: #333">
          {{ $t("m.jy_span8") }}
        </div>
        <div style="margin-top: 5px; font-size: 13px; color: #999">
          {{ rate }}%
        </div>
      </div>
    </div>
    <div class="rlb-list">
      <div
        style="color: #000; font-size: 17px; font-weight: bold"
        class="rlb-title rlb-list-title"
      >
        {{ $t("m.jy_span05") }}
      </div>
    </div>

    <!-- 如果有数据 -->
    <div style="padding: 0 15px">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="$t('m.gengduo')"
        @load="onLoad"
      >
        <div class="rlb-li2" v-for="item in list" :key="item" :title="item">
          <div class="rlb-li-l">
            <div style="font-size: 14px; font-weight: bold">
              {{ item.status }}<span v-if="item.status!=='收益'">{{ $t("m.sy_span9") }}</span>
            </div>
            <div class="rlb-time">{{ item.created_at }}</div>
          </div>
          <div
            class="rlb-li-r"
            :style="{
              color: ['转入','收益'].some(v=>v==item.status) ? 'var(--bg-color)' : '#149B79',
            }"
            style="font-size: 18px; font-weight: bold"
          >
            {{ ['转入','收益'].some(v=>v==item.status) ? "+" : "-" }}{{ item.account }}
            {{item.money}}
          </div>
        </div>
      </van-list>
    </div>

    <div style="height: 50px"></div>
  </div>
</template>

<script>
import request from "@utils/request";
export default {
  //   name: "",
  data() {
    return {
      total_money: "",
      day_into: "",
      total_profit: "",
      income: "",
      rate: "",
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 0,
    };
  },
  created() {
    let that = this;
    setTimeout(function () {
      that.ribao();
    }, 1000);
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    async ribao() {
      request
        .get("/user/ribao/head", {}, { login: true })
        .then((res) => {
          console.log("余额宝顶部数据");
          console.log(res);
          this.total_money = res.data.data.tmoney;
          this.day_into = res.data.data.tprofit;
          this.total_profit = res.data.data.money;
          this.income = res.data.data.income;
          this.rate = res.data.data.rate;
        })
        .catch((err) => {
          this.$dialog.error(err.response.data.msg);
        });
    },
    async onLoad() {
      this.page = this.page + 1;
      let _this = this;
      request
        .get("/user/ribao/list", { page: _this.page }, { login: true })
        .then((res) => {
          console.log("余额宝列表数据");
          console.log(res);
          if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
          }
          const names = {1:'转入',2:'转出',3:'收益'}
          for (var i = 0; i < res.data.data.length; i++) {
            this.list.push({
              account: res.data.data[i]['profit']>0 ? res.data.data[i]['profit'] : res.data.data[i]["money"],
              status: names[res.data.data[i]['status']],
              created_at: res.data.data[i]["created_at"],
            });
          }
          this.loading = false;
          if (res.data.data.length < 10) {
            this.finished = true;
          }
        })
        .catch((err) => {
          console.log(err);
          this.$dialog.message("429");
        });
    },
  },
  filters: {
    formatDate: function (value) {
      let date = new Date(value * 1000);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    },
  },
  components: {},
};
</script>

<style scoped lang="less">
@import url("../../../assets/css/rilibao/rilibaoindex.css");
.rlb-btn1:active {
  opacity: 0.3 !important;
}
.rlb-btn2:active {
  opacity: 0.3 !important;
}
/deep/ .van-ellipsis {
  color: #fff;
}

/deep/ .van-hairline--bottom::after {
  border-bottom-width: 0px;
}
/deep/ .van-nav-bar {
  box-shadow: 0 0 0 #ccc;
  background-color: rgba(0, 0, 0, 0);
}
/deep/ .van-nav-bar__title {
  color: #fff;
}
/deep/ .van-icon {
  color: #fff;
}
</style>
